export const glossaryAlphabetsData = [
  '#',
  'A',
  'B',
  'C',
  'D',
  'E',
  'F',
  'G',
  'H',
  'I',
  'J',
  'K',
  'L',
  'M',
  'N',
  'O',
  'P',
  'Q',
  'R',
  'S',
  'T',
  'U',
  'V',
  'W',
  'X',
  'Y',
  'Z',
]

export const COMMONLY_SEARCHED_WIKIS = [
  'AltCoin',
  'Defi',
  'Coinbase',
  'BitCoin',
  'Hodl',
  'Collectibles',
  'ColdWallet',
  'por que',
]
